import script from "./EbookReader.vue?vue&type=script&setup=true&lang=js"
export * from "./EbookReader.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__